import { orderTurboCase } from 'business/order/geoqueue';
import { OrderResponseFromStatusV2 } from 'business/shared/infra';
import type { MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import orderActions from 'redux/actions/orders-actions/orders.actions';

export function useNewOrderCard(props: Props) {
  const { order } = props;
  const { id: orderId } = order;
  const { isTurboqueue } = orderTurboCase({ order });
  const reduxDispatch = useDispatch();

  function handleOpenOrderDetail(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    reduxDispatch(orderActions.openOrderDetailDialog(orderId));
  }

  return {
    isTurboqueue,
    handleOpenOrderDetail,
  };
}

interface Props {
  order: OrderResponseFromStatusV2;
}
